import type { OidcClient } from '@axa-fr/react-oidc';
import Cookies from 'js-cookie';

import { getSessionCookie, getSitecoreCookie, getSitecoreCookieDomain } from '@shared/configs/configs/config';
import { LOGOUT_PATH } from '@shared/constants/paths';

const setIdTokenCookies = (tokens: OidcClient['tokens']): void => {
  const idTokenExpiry = tokens?.idTokenPayload?.exp as number;

  if (idTokenExpiry) {
    const expiryDate = new Date(idTokenExpiry * 1000);
    Cookies.set(getSitecoreCookie(), '1', {
      path: '/',
      domain: getSitecoreCookieDomain(),
      expires: expiryDate,
      secure: true,
      sameSite: 'strict',
    });
    Cookies.set(getSessionCookie(), tokens?.idToken, {
      path: LOGOUT_PATH,
      expires: expiryDate,
      secure: true,
      sameSite: 'strict',
    });
  }
};

export { setIdTokenCookies };
